import { Navigate } from 'react-router-dom';
import { useLoggedInUser } from '../hooks/useLoggedInUser';
import { getHomePage } from '../utils/getHomePage';
import Layout from './Layout';
import LoadingScreen from './LoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: readonly string[];
}

export default function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps) {
  const { user, isChecking } = useLoggedInUser();

  if (isChecking) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={getHomePage(user.role)} replace />;
  }

  return <Layout>{children}</Layout>;
}
